/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AcceptancesControllerCheckStatusQueryResponse, AcceptancesControllerCheckStatusPathParams, AcceptancesControllerCheckStatus401 } from "../../models/acceptancesController/AcceptancesControllerCheckStatus";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { acceptancesControllerCheckStatus } from "../../clients/acceptancesService/acceptancesControllerCheckStatus";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const acceptancesControllerCheckStatusQueryKey = (principalId: AcceptancesControllerCheckStatusPathParams["principalId"], principalType: AcceptancesControllerCheckStatusPathParams["principalType"], type: AcceptancesControllerCheckStatusPathParams["type"]) => [{
  url: '/api/v1/acceptances/:principalType/:principalId/:type',
  params: {
    principalType: principalType,
    principalId: principalId,
    type: type
  }
}] as const;
export type AcceptancesControllerCheckStatusQueryKey = ReturnType<typeof acceptancesControllerCheckStatusQueryKey>;
export function acceptancesControllerCheckStatusQueryOptions(principalId: AcceptancesControllerCheckStatusPathParams["principalId"], principalType: AcceptancesControllerCheckStatusPathParams["principalType"], type: AcceptancesControllerCheckStatusPathParams["type"], config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = acceptancesControllerCheckStatusQueryKey(principalId, principalType, type);
  return queryOptions<AcceptancesControllerCheckStatusQueryResponse, ResponseErrorConfig<AcceptancesControllerCheckStatus401>, AcceptancesControllerCheckStatusQueryResponse, typeof queryKey>({
    enabled: !!(principalId && principalType && type),
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return acceptancesControllerCheckStatus(principalId, principalType, type, config);
    }
  });
}

/**
 * @summary Check acceptance status for a specific agreement type
 * {@link /api/v1/acceptances/:principalType/:principalId/:type}
 */
export function useAcceptancesControllerCheckStatus<TData = AcceptancesControllerCheckStatusQueryResponse, TQueryData = AcceptancesControllerCheckStatusQueryResponse, TQueryKey extends QueryKey = AcceptancesControllerCheckStatusQueryKey>(principalId: AcceptancesControllerCheckStatusPathParams["principalId"], principalType: AcceptancesControllerCheckStatusPathParams["principalType"], type: AcceptancesControllerCheckStatusPathParams["type"], options: {
  query?: Partial<QueryObserverOptions<AcceptancesControllerCheckStatusQueryResponse, ResponseErrorConfig<AcceptancesControllerCheckStatus401>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? acceptancesControllerCheckStatusQueryKey(principalId, principalType, type);
  const query = useQuery({
    ...acceptancesControllerCheckStatusQueryOptions(principalId, principalType, type, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AcceptancesControllerCheckStatus401>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}